export class ActivityReservation {
	activityReservationId: number;
	reservationNumber: string;   // e.g. KBM-ACT-1041

	// Guest Information
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	numGuests: number;
	specialRequests: string;

	// Stay Information
	property: string;
	unit: string;
	checkIn: Date;
	checkOut: Date;

	// Activity Booking
	activityIds: string;         // comma-separated activity IDs
	activityDate: Date;
	preferredTime: string;

	// Payment
	amountDue: number;
	amountPaid: number;
	paymentStatus: string;       // paid | partial | unpaid | refunded

	// Booking Status
	bookingStatus: string;       // confirmed | pending | cancelled | completed

	// Notes
	staffNotes: string;
}
